import React from 'react';
import cn from 'classnames';
import { LeftArrowIcon } from './LeftArrowIcon';
import './back-button.scss';

export interface BackButtonProps extends React.ComponentProps<'button'> {
    className?: string;
    text?: string;
    gaText?: string;
}

export function BackButton({ className, gaText, text = 'Back to previous screen', ...props }: BackButtonProps) {
    return (
        <button className={cn('back-button__button', className)} {...props}>
            <div className={'back-button__buttonWrapper'}>
                <LeftArrowIcon className='back-button__icon' />
                <div className={'back-button__buttonText'} data-ga={gaText}>
                    {text}
                </div>
            </div>
        </button>
    );
}
